/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Adjust_SubmitInputs */

const vi_customer_debt_adjust_submit = /** @type {(inputs: Customer_Debt_Adjust_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận điều chỉnh`)
};

/**

* @param {Customer_Debt_Adjust_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_adjust_submit = /** @type {((inputs?: Customer_Debt_Adjust_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Adjust_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_adjust_submit(inputs)
});